"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
/**
 *
 * @param event
 * @param prevState
 */
function default_1(event, prevState = {}) {
    const order = prevState;
    if (order.amountDue == 0) {
        (0, utils_1.updateOrderAndItemsStatus)(order, domain_1.OrderStatus.COMPLETED, domain_1.OrderItemStatus.COMPLETED);
    }
    else {
        (0, utils_1.updateOrderAndItemsStatus)(order, domain_1.OrderStatus.IN_PROGRESS, domain_1.OrderItemStatus.IN_PROGRESS);
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=removeOrderHold.js.map